import {
    setTubingPressure,
    setCasingPressure,
    setInflowTypeLstVal,
    setProductivityIndex,
    setStaticBottomHolePressurePI,
    setStaticFluidLevelFromSurfacePI,
    setDesiredProductionRate,
    setStaticBottomHolePressureP,
    setFlowingBottomHolePressureP,
    setTestFlowRate,
    setStaticFluidLevelFromSurfaceHead,
    setProducingFluidLevelFromSurfaceHead,
    setTestFlowRateHead,
    setSettingDepthReference,
    setSettingDepth,
    setPumpSettingVerticalDepth,
    setReservoirDatum,
    setFlopValue,
    setWellTabDetails,
    setHiddenHeadPIIPType,
    setInflowCalculations,
    setPumpSuctionPressure,
} from "../../../store/jetlift/jetlift-input/WellSlice";
import { FlopPayload } from "../../../store/model/calculations/fluid";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";

const useJetliftWellFacade = () => {
    const dispatch = useAppDispatch();

    const updateWellDetails = (payload: any) => {
        return dispatch(setWellTabDetails(payload));
    };

    // Surface Conditions
    const updateTubingPressure = (value: any) => {
        return dispatch(setTubingPressure(value));
    };

    const updateCasingPressure = (value: number) => {
        return dispatch(setCasingPressure(value));
    };

    // Inflow Type
    const updateInflowTypeLstVal = (value: string) => {
        return dispatch(setInflowTypeLstVal(value));
    };

    // Productivity Index (PI) Section
    const updateProductivityIndex = (value: number) => {
        return dispatch(setProductivityIndex(value));
    };

    const updateStaticBottomHolePressurePI = (value: number) => {
        return dispatch(setStaticBottomHolePressurePI(value));
    };

    const updateStaticFluidLevelFromSurfacePI = (value: number) => {
        return dispatch(setStaticFluidLevelFromSurfacePI(value));
    };

    const updateDesiredProductionRate = (value: number) => {
        return dispatch(setDesiredProductionRate(value));
    };

    // Pressure Section (P)
    const updateStaticBottomHolePressureP = (value: number) => {
        return dispatch(setStaticBottomHolePressureP(value));
    };

    const updateFlowingBottomHolePressureP = (value: number) => {
        return dispatch(setFlowingBottomHolePressureP(value));
    };

    const updateTestFlowRate = (value: number) => {
        return dispatch(setTestFlowRate(value));
    };

    // Head Section
    const updateStaticFluidLevelFromSurfaceHead = (value: number) => {
        return dispatch(setStaticFluidLevelFromSurfaceHead(value));
    };

    const updateProducingFluidLevelFromSurfaceHead = (value: number) => {
        return dispatch(setProducingFluidLevelFromSurfaceHead(value));
    };

    const updateTestFlowRateHead = (value: number) => {
        return dispatch(setTestFlowRateHead(value));
    };

    // Setting Dept

    const updateSettingDepthReference = (value: number) => {
        return dispatch(setSettingDepthReference(value));
    };

    const updateSettingDepth = (value: number) => {
        return dispatch(setSettingDepth(value));
    };

    const updatePumpSettingVerticalDepth = (value: number) => {
        return dispatch(setPumpSettingVerticalDepth(value));
    };

    const updateReservoirDatum = (value: number) => {
        return dispatch(setReservoirDatum(value));
    };
    const updateFlop = (value: number) => {
        return dispatch(setFlopValue(value));
    };
    const updateHiddenHeadPIIPType = (payload: string) => dispatch(setHiddenHeadPIIPType(payload));
    const updateInflowCalculations = (payload: any) => dispatch(setInflowCalculations(payload));

    const updatePumpSuctionPressure = (value: number) => {
        return dispatch(setPumpSuctionPressure(value));
    };

    return {
        updateWellDetails,
        updateTubingPressure,
        updateCasingPressure,
        updateInflowTypeLstVal,
        updateProductivityIndex,
        updateStaticBottomHolePressurePI,
        updateStaticFluidLevelFromSurfacePI,
        updateDesiredProductionRate,
        updateStaticBottomHolePressureP,
        updateFlowingBottomHolePressureP,
        updateTestFlowRate,
        updateStaticFluidLevelFromSurfaceHead,
        updateProducingFluidLevelFromSurfaceHead,
        updateTestFlowRateHead,
        updateSettingDepthReference,
        updateSettingDepth,
        updatePumpSettingVerticalDepth,
        updateReservoirDatum,
        updateFlop,
        updateHiddenHeadPIIPType,
        updateInflowCalculations,
        updatePumpSuctionPressure,
    };
};

export default useJetliftWellFacade;
